import { defaultPathComponent } from '@common/constants/shared';
import { ILabel } from '@common/types/element';
import { getValueBindingComponent } from '@common/utils/component';
import {
  getActions,
  getItemListClick,
} from '@common/utils/handleActions/func/helps';
import { isEmpty } from 'lodash';
import React, { FC } from 'react';
import { Text, View, Linking } from 'react-native';
import createStyles from './style';

const parseTextWithInteractiveElements = (text: string) => {
  if (!text) return '';
  const urlRegex = /(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/gi;
  const parts = text.split(urlRegex);

  return parts.map((part, index) => {
    if (part.match(urlRegex)) {
      const url = part.match(/^(https?:\/\/[^\s]+)/) ? part : `https://${part}`;
      return (
        <Text
          key={index}
          style={{ color: 'blue' }}
          onPress={() => Linking.openURL(url)}
        >
          {part}
        </Text>
      );
    }
    return <Text key={index}>{part}</Text>;
  });
};

const CusLabel: FC<ILabel> = (attrs) => {
  const text = getValueBindingComponent(
    attrs,
    defaultPathComponent[attrs.type]
  );
  const styles = createStyles(attrs);

  const handlePress = (event: any) => {
    event.preventDefault();
    let arrayAction = getActions(attrs.actions);
    attrs.onPress &&
      attrs.onPress(arrayAction, {
        itemListClick: getItemListClick(attrs?.record),
      });
  };

  return (
    <View style={styles.container}>
      <Text
        style={styles.text}
        numberOfLines={attrs.multiline ? 0 : 1}
        {...(!isEmpty(attrs.actions) ? { onPress: handlePress } : {})}
      >
        {parseTextWithInteractiveElements(text.replace(/\n$/, ''))}
        {attrs.children}
      </Text>
    </View>
  );
};

export default CusLabel;
